<template lang="html">
  <div v-if="embeded" class="fc-a-loader">
    <div class="fc-a-loader__image"></div>
  </div>
  <div v-else class="row">
    <div class="col-12">
      <article class="fc-m-container">
        <div class="fc-a-loader">
          <div class="fc-a-loader__image"></div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: { embeded: Boolean }
};
</script>

<style lang="scss"></style>
